import React, { useState, useRef, useEffect } from "react";

import styled from "styled-components";
import scrollTo from "gatsby-plugin-smoothscroll";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
// import { Link } from "gatsby";
import Select from "react-select";

import { SelectCityPopover } from "./SelectCityPopover";
import Button from "../ui/buttons";

import { LocaleContext, useI18n, useCustomI18n } from "../../../locale.js";
import { ServerDataContext } from '../../../serverData';

import logo from "../../assets/logo.svg";

import { I18nextContext, Link, useI18next } from 'gatsby-plugin-react-i18next';

// pass onBook functions

function useOutsideAlerter(ref, setShowDropdown) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setShowDropdown]);
}

const NavBar = ({ city, isBirthday, isGiftcard }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const wrapperRef = useRef(null);
  const breakpoints = useBreakpoint();

  useOutsideAlerter(wrapperRef, setShowDropdown, showDropdown);

  const options = [
    { value: "ua", label: "UA" },
    { value: "ru", label: "RU" },
    { value: "en", label: "EN" },
  ];

  const pricesText = useI18n("navbar.prices");
  const contactsText = useI18n("navbar.contacts");
  const buttonText = useI18n("navbar.book");
  const birthdaysText = useI18n("navbar.birthdays");
  const gamesText = useI18n("navbar.games");
  const reviewsText = useI18n("navbar.reviews");
  const faqText = useI18n("navbar.faq");
  const certificatesText = useI18n("navbar.certificates");
  const {languages, changeLanguage, originalPath} = useI18next();
  const [i18Locale, seti18Locale] = useState()
  const context = React.useContext(I18nextContext);

  const flags = {
    ua: "🇺🇦",
    en: "🇬🇧",
    ru: "💩"
  }

  const langList = () => {
    const opt = []
    languages.forEach(lng => {
      const item = {
        value: lng.toString(),
        label: lng.toUpperCase().toString()
        // label: flags[lng]
      }
      opt.push(item)
    })
    return opt
  }

  return (
    <NavbarStyled>
      <NavbarWrapStyled>
        <NavbarBlockStyled>
          <NavbarItemLogo>
            <Link to={"/" + city.slug}>
              <img src={logo} alt="Logo" />
            </Link>
          </NavbarItemLogo>
          <NavbarSelectItem hideOnMobile>
            <LocaleContext.Consumer>
              {({ locale, changeLocale }) => (
                <SelectStyled
                  options={langList()}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  value={langList().find((c) => c.value === context.language)}
                  onChange={(option) => {
                    changeLanguage(option.value)
                    changeLocale(option.value)
                  }}
                  classNamePrefix="select"
                  isSearchable={false}
                />
              )}
            </LocaleContext.Consumer>
          </NavbarSelectItem>

          <NavbarItem>
            <AddressButtonStyled
              onClick={() => setShowDropdown(!showDropdown)}
              title={useCustomI18n(city.name)}
              variant="outlined"
            >
              {useCustomI18n(city.name)}
            </AddressButtonStyled>
          </NavbarItem>
        </NavbarBlockStyled>

        <NavbarBlockStyled desktopSize>
          <NavbarItem marginRight>
            <div
              onClick={() => scrollTo("#prices")}
              onKeyDown={() => scrollTo("#prices")}
              role="button"
              tabIndex="0"
            >
              {pricesText}
            </div>
          </NavbarItem>
          <NavbarItem marginRight>
            <div
              onClick={() => scrollTo("#contacts")}
              onKeyDown={() => scrollTo("#contacts")}
              role="button"
              tabIndex="0"
            >
              {contactsText}
            </div>
          </NavbarItem>
          <NavbarItem marginRight>
            <Link to={`/${city.slug}/birthday`}>{birthdaysText}</Link>
          </NavbarItem>
          <NavbarItem marginRight>
            <Link to={`/${city.slug}/gift-cards`}>{certificatesText}</Link>
          </NavbarItem>
          <ButtonNavbarStyled
            title={buttonText}
            variant="outlined"
            onClick={() => scrollTo(isBirthday ? "#prices" : "#booking")}
          />
        </NavbarBlockStyled>

        <ServerDataContext.Consumer>
          {({ getData }) => (
            <SelectCityPopover
              wrapperRef={wrapperRef}
              onClose={(selectedCityId) => {
                setShowDropdown(false);
                getData(selectedCityId);
              }}
              visible={showDropdown}
              currentCity={city.slug}
            />
          )}
        </ServerDataContext.Consumer>

        {breakpoints.medium ? (
          <MobileMenuIconStyled
            showMenu={showMenu}
            onClick={() => setShowMenu(!showMenu)}
          >
            <div />
            <div />
            <div />
          </MobileMenuIconStyled>
        ) : null}

        {breakpoints.medium ? (
          <NavbarMobileStyled showMenu={showMenu}>
            <NavbarItem>
              <div
                onClick={() => {
                  scrollTo(isGiftcard ? "#gift-cards" : "#prices");
                  setShowMenu(false);
                }}
                onKeyDown={() => {
                  scrollTo(isGiftcard ? "#gift-cards" : "#prices");
                  setShowMenu(false);
                }}
                role="button"
                tabIndex="0"
              >
                {pricesText}
              </div>
            </NavbarItem>
            {!isGiftcard && (
              <NavbarItem>
                <div
                  onClick={() => {
                    scrollTo("#games");
                    setShowMenu(false);
                  }}
                  onKeyDown={() => {
                    scrollTo("#games");
                    setShowMenu(false);
                  }}
                  role="button"
                  tabIndex="0"
                >
                  {gamesText}
                </div>
              </NavbarItem>
            )}

            <NavbarItem>
              <div
                onClick={() => {
                  scrollTo(isBirthday ? "#faq" : "#reviews");
                  setShowMenu(false);
                }}
                onKeyDown={() => {
                  scrollTo(isBirthday ? "#faq" : "#reviews");
                  setShowMenu(false);
                }}
                role="button"
                tabIndex="0"
              >
                {isBirthday ? faqText : reviewsText}
              </div>
            </NavbarItem>
            <NavbarItem>
              <div
                onClick={() => {
                  scrollTo("#contacts");
                  setShowMenu(false);
                }}
                onKeyDown={() => {
                  scrollTo("#contacts");
                  setShowMenu(false);
                }}
                role="button"
                tabIndex="0"
              >
                {contactsText}
              </div>
            </NavbarItem>
            <NavbarItem>
              <Link
                to={`/${city.slug}/gift-cards`}
                onClick={() => setShowMenu(false)}
              >
                {certificatesText}
              </Link>
            </NavbarItem>
            <NavbarItem>
              <Link
                to={`/${city.slug}/birthday`}
                onClick={() => setShowMenu(false)}
              >
                {birthdaysText}
              </Link>
            </NavbarItem>
            <NavbarSelectItem>
              <LocaleContext.Consumer>
              {({ locale, changeLocale }) => (
                <SelectStyled
                  options={langList()}
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  value={langList().find((c) => c.value === context.language)}
                  onChange={(option) => {
                    changeLanguage(option.value)
                    changeLocale(option.value)
                  }}
                  classNamePrefix="select"
                  isSearchable={false}
                />
              )}
            </LocaleContext.Consumer>
            </NavbarSelectItem>
            <ButtonStyled
              title={buttonText}
              variant="outlined"
              onClick={() => {
                scrollTo(isBirthday ? "#prices" : "#booking");
                setShowMenu(false);
              }}
            />
          </NavbarMobileStyled>
        ) : null}
      </NavbarWrapStyled>
    </NavbarStyled>
  );
};

export default NavBar;

const NavbarStyled = styled.nav`
  height: 100px;
  width: 100%;

  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 10;

  background: linear-gradient(
    180deg,
    rgba(3, 3, 3, 0.7) 0%,
    rgba(3, 3, 3, 0) 182%
  );
  backdrop-filter: blur(4px);

  -webkit-backface-visibility: hidden;

  @media ${(props) => props.theme.breakpoints.laptop} {
    height: 80px;
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    height: 60px;
  }
`;
const NavbarWrapStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  flex-wrap: wrap;

  max-width: 1170px;
  height: 100%;
  margin: auto;

  z-index: 1;
  position: relative;

  @media ${(props) => props.theme.breakpoints.desktop} {
    max-width: 1080px;
  }
  @media ${(props) => props.theme.breakpoints.large} {
    padding: 0 1rem;
  }
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 0 1rem 0 0;
  }
`;

const NavbarItem = styled.div`
  display: flex;

  margin-right: ${(props) => props.marginRight && "25px"};

  position: relative;
  cursor: pointer;
  > div,
  > a {
    padding: 0.4em 0.1em;
    font-size: 1rem;
    color: #fff;
    font-family: ${(props) => props.theme.fonts.futura};
    border-bottom: 1px solid transparent;
    &:hover {
      border-bottom-color: ${(props) => props.theme.colors.green};
    }
    @media ${(props) => props.theme.breakpoints.medium} {
      &:hover {
        border-bottom: unset;
      }
    }
  }

  @media ${(props) => props.theme.breakpoints.large} {
    margin-right: ${(props) => props.marginRight && "15px"};
  }

  @media ${(props) => props.theme.breakpoints.laptop} {
    margin-right: 0;
    > div,
    > a {
      padding: 0.6rem;
      font-size: 1.1rem;
      text-align: left;
    }
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    > div,
    > a {
      padding-left: 0;
    }
  }
`;

const NavbarSelectItem = styled(NavbarItem)`
  margin: 0 20px;
  width: 60px;

  div:hover {
    border-bottom: unset;
  }
  border-bottom: unset !important;

  @media ${(props) => props.theme.breakpoints.large} {
    margin: 0 10px;
  }

  @media ${(props) => props.theme.breakpoints.laptop} {
    margin: 0 5px 0 -10px;
  }

  @media ${(props) => props.theme.breakpoints.medium} {
    display: ${(props) => (props.hideOnMobile ? "none" : "flex")};
    margin: 0 0 0 -8px;
    width: 60px !important;
  }
`;

const NavbarBlockStyled = styled.div`
  display: flex;
  align-items: center;
  @media ${(props) => props.theme.breakpoints.medium} {
    display: ${(props) => (props.desktopSize ? "none" : "flex")};
  }
`;

const NavbarItemLogo = styled(NavbarItem)`
  img {
    width: 200px;
    height: 60px;

    object-fit: contain;
  }
  a {
    display: flex;
    padding-left: 0px;

    font-weight: 800;

    &:hover {
      border-bottom: unset;
    }
  }
  @media ${(props) => props.theme.breakpoints.laptop} {
    img {
      width: 170px;
      height: 50px;
    }
    a {
      padding: 0.5rem 0;
    }
  }
  @media ${(props) => props.theme.breakpoints.tablet} {
    padding: 0;
    img {
      width: 95px;
      height: 35px;
    }
  }
  @media ${(props) => props.theme.breakpoints.small} {
    padding-left: 0.5rem;
  }
`;

const AddressButtonStyled = styled(Button)`
  && {
    justify-content: flex-start;

    min-width: 8rem;
    font-size: 1rem;

    &:after {
      content: "";

      width: 0;
      height: 0;
      margin-left: auto;

      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid ${(props) => props.theme.colors.green};
      z-index: 1;
    }

    @media ${(props) => props.theme.breakpoints.laptop} {
      min-width: 6.25rem;
      padding: 0.25rem 0.5rem;
    }
    @media ${(props) => props.theme.breakpoints.medium} {
      margin-left: 1rem;
      min-width: 8rem;
      padding: 0.5rem 1rem;
    }
    @media ${(props) => props.theme.breakpoints.tablet} {
      min-width: 7rem;
      padding: 0.25rem 0.75rem;
      height: 2.25rem;
    }
  }
`;

const MobileMenuIconStyled = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  height: 23px;
  padding: 2px 0;

  border: none;
  background: transparent;
  z-index: 10;

  div {
    width: 24px;
    height: 2.5px;

    position: relative;

    background-color: ${(props) => props.theme.colors.green};
    border-radius: 5px;
    transform-origin: 1px;
    transition: opacity 300ms, transform 300ms;

    :first-child {
      transform: ${({ showMenu }) =>
    showMenu ? "rotate(45deg)" : "rotate(0)"};
    }
    :nth-child(2) {
      opacity: ${({ showMenu }) => (showMenu ? "0" : "1")};
    }
    :nth-child(3) {
      transform: ${({ showMenu }) =>
    showMenu ? "rotate(-45deg)" : "rotate(0)"};
    }
  }
`;

const NavbarMobileStyled = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  height: 100vh;
  width: 100vw;
  padding: 20px;

  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 5;

  background-color: #03050c;
  transition: all 0.3s;
  transform: ${({ showMenu }) =>
    showMenu ? "translateX(0)" : "translateX(-100vw)"};

  & ${NavbarItem} {
    width: 100%;
    > div {
      width: 100%;
    }

    &:not(:last-child) {
      border-bottom: 1px solid grey;
    }
  }
`;

const SelectStyled = styled(Select)`
  .select__control {
    background-color: transparent;
    border: none;
    box-shadow: none;
    outline: none;
    cursor: pointer;

    &:after {
      content: "";

      width: 0;
      height: 0;
      margin-left: auto;

      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid ${(props) => props.theme.colors.green};
      z-index: 1;
    }
  }
  .select__single-value {
    color: ${(props) => props.theme.colors.white};
    margin: 0;
    width: 30px;
  }
  .select__menu {
    border-radius: 0;
    padding: 0;
  }

  .select__option {
    background-color: ${(props) => props.theme.colors.white}!important;
    cursor: pointer;
    color: ${(props) => props.theme.colors.black};
    &:hover {
      color: ${(props) => props.theme.colors.green};
    }
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    .select__menu {
      margin-top: -20px;
    }
  }
`;
const ButtonStyled = styled(Button)`
  width: 100%;
  margin: 20px auto;

  && {
    font-size: 1rem;
  }
`;
const ButtonNavbarStyled = styled(Button)`
  && {
    font-size: 1rem;
  }
`;
